// extracted by mini-css-extract-plugin
module.exports = {"form":"Form_form__8uBUe","button":"Form_button__kCaEL"};